import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getTenantFromToken } from 'utils/routeUtils';

const Logo = ({
  at,
  width,
  className,
  textClass,
  monitoringLocationData,
  firstMonitoringCluster,
  ...rest
}) => {
  // eslint-disable-next-line no-undef
  const { cluster: clusterParam } = useParams();

  const domain = window.location.hostname;
  const clientName = domain?.split('.')[0].toUpperCase();

  let logo;
  if (clientName == 'SESTA') {
    logo = require('../../assets/img/illustrations/sesta_logo.png');
  } else if (clientName == 'RPLC') {
    logo = require('../../assets/img/illustrations/idh_logo.png');
  } else if (clientName == 'AMBUJAFOUNDATION') {
    logo = require('../../assets/img/illustrations/ambuja_logo.png');
  } else if (clientName == 'MRV') {
    logo = require('../../assets/img/illustrations/farmsio_logo.png');
  } else if (clientName == 'FCS-DB') {
    logo = require('../../assets/img/illustrations/Seal_of_Maharashtra_bo.png');
  } else if (clientName == 'TNSMRV' || clientName == 'TNS') {
    logo = require('../../assets/img/illustrations/tns_logo.png');
  } else {
    logo = require('../../assets/img/illustrations/farmsio_logo.png');
  }

  const tenant = getTenantFromToken();

  const isOffline = !navigator.onLine;

  let route;
  if (!isOffline) {
    if (
      clientName === 'TNSMRV' ||
      clientName === 'MRV' ||
      clientName === 'TNS'
    ) {
      route = `/${tenant}/dashboardAnalytics`;
    } else {
      route =
        `/${tenant}/monitor/` +
        (clusterParam &&
        monitoringLocationData?.some(item => item.key === clusterParam)
          ? clusterParam
          : firstMonitoringCluster);
    }
  }

  return (
    <Link
      to={route || '#'}
      onClick={e => {
        if (isOffline) e.preventDefault();
      }}
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          'align-items-center',
          { 'dashboard-logo-container': at === 'navbar-vertical' },
          { 'align-items-center': at === 'navbar-top' },
          { 'flex-center fw-bolder fs-5 mb-4': at === 'auth' },
          className
        )}
      >
        {/* <img className="me-2" src={logo} alt="Logo" width={width} /> */}
        <span className={classNames('font-sans-serif', textClass)}>
          <img
            className="me-2 mb-2 dashboard-logo"
            src={logo}
            alt="Logo"
            style={{
              width:
                clientName == 'FCS-DB'
                  ? '70px'
                  : clientName == 'TNSMRV'
                  ? '110px'
                  : '90px'
            }}
          />
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
  monitoringLocationData: PropTypes.arrayOf(PropTypes.object), // Add this line
  firstMonitoringCluster: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
